import styled from 'styled-components'

const FinanceInfoGrid = styled.div<{ $columns?: number }>`
  display: grid;
  grid-template-columns: repeat(
    ${(props) => props.$columns || 3},
    minmax(0, 1fr)
  );
  gap: 16px;

  @media (max-width: 1024px) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  @media (max-width: 720px) {
    grid-template-columns: 1fr;
  }
`

export default FinanceInfoGrid
